module.exports = __webpack_public_path__ + "media/infectious colitis.db418cca.wav";